import MapModal from './containers/MapModalContainer'

export default MapModal
